import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { Table } from 'components'
import { VouchersActions } from 'store/models/vouchers'
import { vouchersColumns } from './vouchersUtils'

export const AllVouchers = () => {
    const dispatch = useDispatch()
    const { currentPage, getVouchersDetailsLoading, getVouchersDetailsError, LastEvaluatedKey, voucherColumnSortBy, vouchersDetails } = useSelector(
        GET_STORE.VOUCHERS
    )
    const tableColumns = useMemo(() => vouchersColumns, [vouchersColumns])
    const initialSortBy = useMemo(() => voucherColumnSortBy, [voucherColumnSortBy])

    const data = vouchersDetails[currentPage] || []

    const onSaveSort = column => dispatch(VouchersActions.setVoucherColumnsSort(column))

    return (
        <Table
            {...{
                canGoLeft: currentPage > 0,
                canGoRight: !!LastEvaluatedKey || vouchersDetails.length > currentPage + 1,
                columns: tableColumns,
                currentPage: currentPage + 1,
                emptyStateText: getVouchersDetailsError,
                data,
                displayCount: true,
                initialSortBy,
                loadingData: getVouchersDetailsLoading,
                onSaveSort,
                sortable: true,
                sortableColumns: tableColumns.map(({ Header }) => Header),
                title: 'All Vouchers',
            }}
        />
    )
}
